import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';

import { injectHouseholdsSlice } from '@/app/householdsApi';
import { toUser } from '@/features/auth/toUser';
import { User } from '@/features/auth/types';

export const authApi = injectHouseholdsSlice({
  baseUrl: '',
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getCurrentUser: builder.query<User, void>({
      query: () => ({
        url: '/user',
      }),
      transformResponse: toUser,
    }),
  }),
});

export const { useLazyGetCurrentUserQuery } = authApi;
